import {Hydra} from '../generic/hydra';

import {
    AideFraisTypeDescriptionTranslation as AideFraisTypeDescriptionTranslationBaseInterface
} from '../../interface/api/AideFraisTypeDescriptionTranslation';

export type AideFraisTypeDescriptionTranslationInterface = AideFraisTypeDescriptionTranslationBaseInterface;

export class AideFraisTypeDescriptionTranslation extends Hydra implements AideFraisTypeDescriptionTranslationInterface {

    id?: number | null;

    /* ex: en, fr, etc.
     */
    locale?: string | null;

    description?: string | null;


    constructor(options: AideFraisTypeDescriptionTranslationInterface = null) {
        super();
        if(options) {
            Object.assign(this, options);
        }
    }

}
